import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useState } from "react";
import type { JSX, ReactNode } from "react";

import { APIError } from "../lib/http.js";
import { toast } from "../lib/toast.js";

function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: (failureCount, error) => {
          if (error instanceof APIError && error.status >= 400 && error.status < 500) return false;
          return failureCount < 2;
        },
        refetchOnWindowFocus: false,
      },
      mutations: {
        onError: (error) => {
          const msg =
            error instanceof APIError ? error.message : "Something went wrong";
          const detail = error instanceof APIError ? error.displayDetail : undefined;
          toast.error(msg, detail);
        },
      },
    },
  });
}

export function QueryProvider({ children }: { children: ReactNode }): JSX.Element {
  const [client] = useState(createQueryClient);
  return (
    <QueryClientProvider client={client}>
      {children}
      {import.meta.env.DEV ? <ReactQueryDevtools initialIsOpen={false} /> : null}
    </QueryClientProvider>
  );
}
